var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudyTutorme = function SvgStudyTutorme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 124 123"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#study-tutorme_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M49.49 1.843c.973-2.255 2.927-2.548 4.074-.285 3.718 9.818 5.673 21.125 9.502 30.793.601 1.519 1.535 3.457 2.698 4.612l-.015.008c.886.886 2.808 2.026 4.002 2.524 9.162 3.806 21.529 5.103 30.548 8.996 3.118 1.345 2.682 3.789-.285 5-9.154 3.742-21.116 5.143-30.27 8.877-3.062 1.25-5.31 3.489-6.52 6.519-3.916 9.803-5.862 21.441-9.676 31.41-.743 2.239-3.11 1.994-3.964 0-3.805-9.882-5.648-21.766-9.675-31.41-1.337-3.196-3.26-5.198-6.512-6.527-9.194-3.75-21.544-5.095-30.556-8.988C.397 52.32-.18 50.057 2.32 48.743c9.597-3.52 20.35-5.396 29.883-8.869 3.67-1.337 6.028-2.896 7.61-6.622 4.059-9.557 5.602-21.978 9.677-31.409"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#study-tutorme_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M94.155 69.98c.486-1.128 1.463-1.274 2.037-.143 1.86 4.91 2.836 10.563 4.751 15.397.3.759.767 1.728 1.349 2.305l-.008.004c.443.443 1.404 1.014 2.002 1.263 4.58 1.903 10.763 2.55 15.273 4.497 1.559.672 1.341 1.896-.142 2.5-4.577 1.872-10.558 2.572-15.135 4.439-1.531.625-2.655 1.744-3.26 3.259-1.958 4.901-2.931 10.721-4.838 15.705-.372 1.12-1.555.997-1.982 0-1.903-4.941-2.825-10.883-4.838-15.705-.669-1.598-1.63-2.598-3.256-3.263-4.597-1.875-10.772-2.547-15.277-4.494-1.223-.526-1.512-1.657-.262-2.314 4.798-1.76 10.175-2.698 14.942-4.435 1.836-.668 3.014-1.448 3.805-3.311 2.03-4.779 2.802-10.989 4.839-15.704"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "study-tutorme_svg__a",
    width: 105.743,
    height: 105.886,
    x: 0.704,
    y: -0.001,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1586_49669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1586_49669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "study-tutorme_svg__b",
    width: 53.871,
    height: 53.943,
    x: 69.761,
    y: 69.058,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1586_49669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1586_49669",
    result: "shape"
  })))));
};
export default SvgStudyTutorme;